import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebookLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Facebook logo",
		clipPath: "url(#clip0_9077_34571)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "XMLID_17_",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "XMLID_22_",
				d: "M18.5 9.21777C18.5 4.24668 14.4711 0.217773 9.5 0.217773C4.52891 0.217773 0.5 4.24668 0.5 9.21777C0.5 13.7104 3.78922 17.4338 8.09445 18.1091V11.8214H5.81106V9.21777H8.09445V7.23531C8.09445 4.98145 9.43566 3.7341 11.4923 3.7341C12.4784 3.7341 13.5092 3.91164 13.5092 3.91164V6.12578H12.3751C11.2557 6.12578 10.9105 6.82117 10.9105 7.53133V9.21777H13.4059L13.0065 11.8214H10.9105V18.1091C15.2108 17.4338 18.5 13.7104 18.5 9.21777Z",
				fill: "#1877F2"
			}), /* @__PURE__ */ _jsx("path", {
				id: "XMLID_18_",
				d: "M12.9998 11.8217L13.3995 9.21805H10.9041V7.5316C10.9041 6.82145 11.2543 6.12606 12.3687 6.12606H13.5029V3.91191C13.5029 3.91191 12.4721 3.73438 11.4859 3.73438C9.42965 3.73438 8.08809 4.98207 8.08809 7.23559V9.21805H5.80469V11.8217H8.08809V18.1094C8.54688 18.1832 9.01516 18.218 9.49363 18.218C9.97211 18.218 10.4404 18.1787 10.8992 18.1094V11.8217H12.9998Z",
				fill: "transparent"
			})]
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9077_34571",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white",
			transform: "translate(0.5 0.217773)"
		})
	}) })]
});
export default SvgFacebookLogo;
